<template>
  <b-modal
    v-if="lobbyOffer"
    id="modal-offer-lobby-1"
    class="custom-modal1"
    :hide-footer="true"
    modal-class="custom-modal1"
    @hidden="onHidden"
  >
    <template slot="modal-header" slot-scope="{ close }">
      <a href="#" class="close-button" @click="close()"> </a>
      <div class="headline">
        <img
          :src="
            require(`@/assets/img/shop/offers/overlay-lobby-powerspin-1-panel-hl-${$store.state.locale}.png`)
          "
          class="w-100"
        />
      </div>
    </template>

    <template slot="default">
      <div v-if="rewards[0]" class="offer-reward-container to-center-abs">
        <div
          class="text-center"
          :style="{ visibility: rewards[0].gold > 0 ? 'visible' : 'hidden' }"
        >
          <div class="amount-gold yellow-text">
            {{ formatNumber(rewards[0].gold) }} x
            <div class="icon-gold">
              <BaseAsset asset="primary" size="big" />
            </div>
          </div>
        </div>

        <div
          class="text-center"
          :style="{ visibility: rewards[0].crown > 0 ? 'visible' : 'hidden' }"
        >
          <div class="amount-crown yellow-text">
            {{ formatNumber(rewards[0].crown) }} x
            <div class="icon-crown">
              <BaseAsset asset="secondary" size="big" />
            </div>
          </div>
        </div>

        <div class="bonus-col w-100">
          <div
            class="package-bonus-icons d-flex align-items-center justify-content-around"
          >
            <div
              v-if="rewards[0].card > 0"
              class="package-icon package-bonus-icon-card"
            >
              <div class="icon">
                <BaseAsset asset="cards" size="big" />
              </div>
              <div class="text">{{ formatNumber(rewards[0].card) }} x</div>
            </div>

            <div
              v-if="rewards[0].loyalty > 0"
              class="package-icon package-bonus-icon-loyalty"
            >
              <div class="icon">
                <BaseAsset asset="loyalty" size="big" />
              </div>
              <div class="text">{{ formatNumber(rewards[0].loyalty) }} x</div>
            </div>

            <div
              v-if="rewards[0].elixir > 0"
              class="package-icon package-bonus-icon-elixir"
            >
              <div class="icon">
                <BaseAsset asset="tertiary" size="big" />
              </div>
              <div class="text">{{ formatNumber(rewards[0].elixir) }} x</div>
            </div>

            <div
              v-if="rewards[0].expbooster > 0"
              class="package-icon package-bonus-icon-expbooster"
            >
              <div class="icon">
                <BaseAsset asset="booster" class="h-100" />
              </div>
              <div class="text">
                {{ Math.round(rewards[0].expbooster / 60) }} Min.
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="submit-button to-center-abs"
        @click="buyItem(0, 'Offer', 'Lobby')"
      >
        <div>
          {{ $t("shop.offers.buy_button", { 0: "" }) }}
          <br />
          <span class="big">{{ formatPrice(price) }} €</span>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
import offerModalContent from "@/mixins/offerModalContent.js";
import BaseAsset from "@/components/base/base-asset.vue";

export default {
  name: "ModalOfferLobby1",
  components: { BaseAsset },
  mixins: [offerModalContent],
  data() {
    return { isPipelineOffer: true };
  },

  mounted: function () {
    this.$bvModal.show("modal-offer-lobby-1");
  },
};
</script>
<style lang="scss">
$modal-width: 1000px;
$modal-height: 700px;

#modal-offer-lobby-1 {
  .modal-dialog {
    top: 50px;
    max-width: $modal-width;
    height: $modal-height;

    @media (max-height: 750px) {
      transform: scale(0.8);
      top: -60px;
      margin-bottom: -20%;
    }
  }

  .modal-content {
    width: $modal-width;
    background: url(~@/assets/img/shop/offers/meinekrone-offer-overlay-powerspin-1-panel-v-1.png)
      no-repeat;
    background-size: 100%;
    background-position: bottom center;
  }

  .close-button {
    top: -10px;
    right: -10px;
  }
}
</style>

<style scoped lang="scss">
#modal-offer-lobby-1 {
  .headline {
    position: absolute;
    top: 22px;
    left: 5px;
  }

  .offer-reward-container {
    top: 225px;
    line-height: 1.2;
    text-align: left;
    width: 700px;
    height: 300px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: column;
  }

  .amount-gold {
    font-size: 65.7px;
    font-family: Ubuntu-Bold;
    position: relative;
    display: inline-flex;
    text-align: center;
    padding-right: 80px;

    .icon-gold {
      position: absolute;
      width: 64px;
      right: 0px;
      top: -4px;
    }
  }

  .amount-crown {
    font-size: 65.7px;
    font-family: Ubuntu-Bold;
    position: relative;
    display: inline-flex;
    text-align: center;
    padding-right: 80px;
    margin-top: 10px;

    .icon-crown {
      position: absolute;
      width: 83px;
      right: -10px;
      top: -5px;
    }
  }

  .bonus-col {
    margin-top: 25px;

    .package-bonus-icons {
      padding: 0 25%;
      white-space: nowrap;

      .package-icon {
        width: 93px;
        text-align: center;
      }

      .package-bonus-icon-card {
        .text {
          color: $primary-accent;
          font-family: Ubuntu;
          font-size: 22px;
          margin-top: 5px;
          white-space: nowrap;
        }

        .icon {
          height: 46px;
          margin-left: auto;
          margin-right: auto;
        }
      }
      .package-bonus-icon-loyalty {
        .text {
          color: $primary-accent;
          font-family: Ubuntu;
          font-size: 22px;
          margin-top: 5px;
          white-space: nowrap;
        }

        .icon {
          height: 47px;
          margin-left: auto;
          margin-right: auto;
        }
      }

      .package-bonus-icon-elixir {
        .text {
          color: $primary-accent;
          font-family: Ubuntu;
          font-size: 22px;
          margin-top: 5px;
          white-space: nowrap;
        }

        .icon {
          height: 47px;
          margin-left: auto;
          margin-right: auto;
        }
      }

      .package-bonus-icon-expbooster {
        .text {
          color: $primary-accent;
          font-family: Ubuntu;
          font-size: 22px;
          margin-top: 5px;
          white-space: nowrap;
        }

        .icon {
          height: 47px;
          margin-left: auto;
          margin-right: auto;
        }
      }
    }
  }

  .submit-button {
    width: 405px;
    height: 182px;
    align-items: center;
    justify-content: center;
    font-size: 22px;
    color: white;
    text-transform: uppercase;
    cursor: pointer;
    font-family: Ubuntu-Bold;
    text-align: center;
    padding-left: 85px;
    padding-right: 70px;
    display: inline-flex;
    line-height: 1;
    bottom: -20px;
    left: -28px;
    text-shadow: 1px 2px 4px $text-shadow-dark-green;

    .big {
      color: white;
      font-family: Ubuntu-Bold;
      font-size: 56px;
      text-shadow: 1px 2px 4px $text-shadow-dark-green;
    }
  }
}
</style>
